import { createSelector } from 'reselect';

export const getUserList = state => state.user.userList;
export const getUserListData = createSelector(getUserList, userList => userList?.data);
export const getUserListTotal = createSelector(getUserList, userList => userList?.total);
export const getUserBasicList = state => state.user.userBasicList;
export const getUserBasicListData = createSelector(getUserBasicList, userBasicList => userBasicList?.data);
export const getUserBasicListTotal = createSelector(getUserBasicList, userBasicList => userBasicList?.total);
export const getUser = state => state.user.user;
export const getLoadingStatus = state => state.user.loading;
export const getSavingStatus = state => state.user.saving;
export const getErrorStatus = state => state.user.error;
